import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss']
})
export class SkeletonComponent implements OnInit {
  @Input() width: string = '100%';
  @Input() height: string = '1rem';
  @Input() variant: string = 'text';
  @Input() rounded: string = '';

  constructor() { }

  ngOnInit() { }

  get borderRadius(): string {
    if (this.rounded) { return this.rounded; }
    if (this.variant === 'circle') { return '50%'; }
    if (this.variant === 'text') { return '0.25rem'; }
    return '0.5rem';
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/skeleton/skeleton.component.ts